exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#wrapper {\n    padding: 0 30px;\n}\n\n\n#buttonsWrapper {\n  margin-top: 20px;\n  text-align: right;\n}\n\n\n.shareLink:visited {\n  color: #0000EE;\n}\n\n\n.shareLink {\n  outline: 0;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/ui/dialogs/share-foko-dialog/share-foko-dialog.component.css
// module id = ../../../../../src/app/ui/dialogs/share-foko-dialog/share-foko-dialog.component.css
// module chunks = main